import { isUserAgentMobile, isSite, getScreenWidth } from './wix-sdk-utils';
import { isInWix } from './is-in-wix';

export const getViewportScaleRatio = () => {
  return isUserAgentMobile() && isSite() && isInWix() ? 320 / getScreenWidth() : 1;
};

export const fixViewport = () => {
  if (isSite() && isUserAgentMobile() && isInWix()) {
    const screenWidth = getScreenWidth();
    const viewportAspectRatio = 320 / screenWidth;
    document.body.style.transform = `scale(${viewportAspectRatio})`;
    document.body.style.transformOrigin = '0 0';
    document.body.style.width = `${screenWidth}px`;
    document.body.style.height = `${100 / viewportAspectRatio}%`;
  }
};



// WEBPACK FOOTER //
// ./app/services/fix-viewport.js